import GenmabModule from './GenmabModule';

export default GenmabModule;
